import { WeaverLoading } from 'Components'
import GitlabGraph from './GitlabGraph'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getGravatarUrl } from 'Services/WeaverUtils'
import { assignBranches, orderBranchesByHierarchy } from '../helpers'
import './index.scss'

# TODO: Implement squashing with pagination
# squashSameLane = (commits) ->
#   activeParentMap = {}
#   commits.map((commit, i) ->
#     lastCommit = commits[i - 1]
#     nextCommit = commits[i + 1]
#     if lastCommit?.branch isnt commit.branch or !nextCommit
#       [lastCommit, commit].filter(Boolean).map((c) -> c.dontSquash = true)
#     if !nextCommit
#       commit.parents = []
#       commit.dontSquash = true
#     commit
#   ).reduce((acc, commit) ->
#     [prev..., last] = acc
#     if !commit.dontSquash
#       activeParentMap[commit.branch] ?= { commit..., messages: [] }
#       activeParentMap[commit.branch].parents = commit.parents || []
#       activeParentMap[commit.branch].messages.push(commit.message or 'No description.')
#       toAppend = []
#     else
#       toAppend = [
#         activeParentMap[commit.branch],
#         commit
#       ].filter(Boolean)
#       activeParentMap[commit.branch] = undefined
#     acc.concat(toAppend)
#   , [])

assignLanes = (commits) ->
  laneMap = (await orderBranchesByHierarchy())
    .reduce((acc, curr, i) ->
      acc[curr] = i
      acc
    , {})
  commits.map((c) ->
    if c.branches.length < 1
      c.lane = laneMap[c.branch]
    else
      lanes = _.filter(laneMap, (value, key) -> c.branches.includes(key))
      c.lane = _.min(lanes)
  )

assignParents = (commits) ->
  getParents = ({ mergedCommit, parentCommit, lane }) ->
    [
      mergedCommit && [mergedCommit, lane ]
      parentCommit && [parentCommit, lane]
    ].filter(Boolean)
  commits.map((commit) ->
    commit.parents = getParents(commit)
    commit
  )

hideIrrelevantBranches = (commits, configDataIsVisible) ->
  cleanedCommits = commits.filter(({ branch }) -> branch?)
  if !configDataIsVisible
    cleanedCommits.filter(({ branch }) -> branch isnt "$config")
  else
    cleanedCommits

prepareCommits = (commits, configDataIsVisible) ->
  await assignBranches(commits)
  commits = hideIrrelevantBranches(commits, configDataIsVisible)
  await assignLanes(commits)
  assignParents(commits)
  projectList = await Weaver.User.listProjectUsers()
  # TODO: Implement squashing with pagination
  # squashSameLane(commits)
  #   .map(raphaelizeCommit(projectList))
  commits.map(raphaelizeCommit(projectList))

raphaelizeCommit = (userList) -> (commit, i) ->
  user = userList.find(({ userId }) -> userId is commit.user) or {}
  {
    commit...
    id: commit.uid
    date: commit.timestamp
    message: (
      if commit.messages
        commit.messages.length + ' commits.'
      else
        commit.message or 'No description.'
    )
    messages: commit.messages or [commit.message or 'No description.']
    author:
      name: "#{ user?.firstname } #{ user?.lastname }",
      email: user.email,
      icon: getGravatarUrl(user)
    space: commit.lane
    time: i
    refs: commit.branches.sort().join(' ')
  }

PAGE_SIZE = 10000

monthNames = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
]

getDays = (commits) ->
  commits.map(({ timestamp }) ->
    d = new Date(timestamp)
    [d.getDate(), monthNames[d.getMonth()]]
  )

BranchGraph = ->

  configDataIsVisible = useSelector(({ projects }) ->
    projects.displayConfigEnabled
  )

  graphEl = useRef(undefined)
  [isLoading, setIsLoading] = useState(true)

  useEffect( ->
    ( ->
      graph = new GitlabGraph(graphEl.current, {
        transformCommits: (commits) ->
          await prepareCommits(commits, configDataIsVisible)
        transformDays: getDays
        loadData: (limit, offset) ->
          Weaver.getInstance()
          .currentProject()
          .listCommits(limit, offset)
      })
      await graph.fetchMoreCommits(PAGE_SIZE, 0)
      graph.buildGraph()
      setIsLoading(false)
    )()
    -> graph = undefined
  , [])

  <div
    ref={graphEl}
    className='branch-graph'
  >
    {
      isLoading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <WeaverLoading />
        </div>
      )
    }
  </div>

export default BranchGraph
